import { render, staticRenderFns } from "./TemplatePicker.vue?vue&type=template&id=9388fefc&scoped=true"
import script from "./TemplatePicker.vue?vue&type=script&lang=ts"
export * from "./TemplatePicker.vue?vue&type=script&lang=ts"
import style0 from "./TemplatePicker.vue?vue&type=style&index=0&id=9388fefc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9388fefc",
  null
  
)

export default component.exports